var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgHome(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2320_3298)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M17.9937 8.98242C17.9937 9.61523 17.525 10.1109 16.9937 10.1109H15.9937L16.0156 15.743C16.0156 15.8379 16.0094 15.9328 16 16.0277V16.5938C16 17.3707 15.4406 18 14.75 18H14.25C14.2156 18 14.1813 18 14.1469 17.9965C14.1031 18 14.0594 18 14.0156 18H13H12.25C11.5594 18 11 17.3707 11 16.5938V15.75V13.5C11 12.8777 10.5531 12.375 10 12.375H8C7.44687 12.375 7 12.8777 7 13.5V15.75V16.5938C7 17.3707 6.44063 18 5.75 18H5H4.00313C3.95625 18 3.90937 17.9965 3.8625 17.993C3.825 17.9965 3.7875 18 3.75 18H3.25C2.55937 18 2 17.3707 2 16.5938V12.6562C2 12.6246 2 12.5895 2.00312 12.5578V10.1109H1C0.4375 10.1109 0 9.61875 0 8.98242C0 8.66602 0.09375 8.38477 0.3125 8.13867L8.325 0.28125C8.54375 0.0351562 8.79375 0 9.0125 0C9.23125 0 9.48125 0.0703125 9.66875 0.246094L17.65 8.13867C17.9 8.38477 18.025 8.66602 17.9937 8.98242Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2320_3298"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 18,
    height: 18,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHome);
export default __webpack_public_path__ + "static/media/home.d5efd46f63af65542f4db81bf7d6b583.svg";
export { ForwardRef as ReactComponent };